import { actionTypes } from '../actions/imageModal';

export const imageModalInitialState = {
  items: [],
  currentImage: null,
  isShow: false
};

export default (state = imageModalInitialState, { type, payload }) => {
  switch (type) {
    case actionTypes.SET_ITEMS:
      return {
        ...state,
        items: payload
          .filter(
            ({ content }) =>
              content.attachments && content.attachments.length > 0
          )
          .map(message =>
            message.content.attachments.map((attachment, index) => ({
              ...message,
              attachment,
              attachmentIndex: index
            }))
          )
          .reduce((acc, val) => acc.concat(val), [])
      };
    case actionTypes.OPEN:
      return {
        ...state,
        isShow: true,
        currentImage: state.items.find(item => item.message_id === payload.message_id && item.attachmentIndex === payload.attachmentIndex),
      };
    case actionTypes.CLOSE:
      return {
        ...state,
        isShow: false,
        currentImage: null
      };
    default:
      return state;
  }
};
